import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { OverlayModule } from '@angular/cdk/overlay';
import { TranslateModule } from '@ngx-translate/core';

import { FcpIconModule, FcpTooltipModule } from 'fc-ui-components';

import { OrderMatrixHeadersComponent } from './matrix-headers.component';
import { FormsModule } from '../../../../order-management/retailer-platform/manage-stores/shared';
import { OrderMatrixComponent } from './matrix.component';
import { OrderInputComponent } from './input/input.component';
import { OrderCellComponent } from './cell/cell.component';
import { EllipsisTooltipTextModule } from '../../../../components/ellipsis-tooltip-text';
import { DirectivesModule } from 'app/directives/directives.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        DirectivesModule,
        FcpIconModule,
        TranslateModule,
        EllipsisTooltipTextModule,
        FcpTooltipModule,
        OverlayModule
    ],
    declarations: [OrderMatrixComponent, OrderInputComponent, OrderCellComponent, OrderMatrixHeadersComponent],
    exports: [OrderMatrixComponent]
})
export class OrderMatrixModule {}

export enum MatrixType {
    Unsupported = -1,
    SingleSize,
    Prepacks,
    Compound,
    ShoppingCart
}
